'use strict';

import './saveVehicle.scss';
import template from './saveVehicle.template.html';
import controller from './saveVehicle.controller.js';

function component() {
    return {
        scope: {
            forced: '=',
            iconOnly: '='
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller,
        template
    };

}

export default component;
